const errorMessages = (codeMessage) => {
  switch (codeMessage) {
    case "customer_tax_location_invalid":
      return "Your tax location is invalid";
    case "coupon_expired":
      return "Coupon has expired";
    case "incorrect_zip":
      return "The card’s postal code is incorrect";
    case "payment_method_provider_decline":
      return "The payment or setup attempt was declined by the issuer or customer";
    case "processing_error":
      return "An error occurred while processing the card. Try again later or with a different payment method";
    case "resource_missing":
      return "You don't have any attached payment source or default payment method.";
    default:
      return "Something went wrong";
  }
};

export default errorMessages;
